import { AccountModel } from "@cakemail-org/ui-components-v2"
import { t } from "i18next"


export function getDefaultMergeTags({ account }: { account: AccountModel }) {
    let mergeTags = [
        //Senders info
        {
            name: t("merge-field-sender-name"),
            value: "[SENDER_NAME]",
            type: "text"
        },
        {
            name: t("merge-field-sender-email"),
            value: "[SENDER_EMAIL]",
            type: "text"
        },
        //Client information
        {
            name: t("merge-field-company"),
            value: "[CLIENTS.COMPANY_NAME]",
            type: "text"
        },
        {
            name: t("merge-field-full-address"),
            value: "[CLIENTS.ADDRESS]",
            type: "text"
        },
        {
            name: t("merge-field-address1"),
            value: "[CLIENTS.ADDRESS1]",
            type: "text"
        },
        {
            name: t("merge-field-address2"),
            value: "[CLIENTS.ADDRESS2]",
            type: "text"
        },
        {
            name: t("merge-field-city"),
            value: "[CLIENTS.CITY]",
            type: "text"
        },
        {
            name: t("merge-field-province"),
            value: "[CLIENTS.PROVINCE]",
            type: "text"
        },
        {
            name: t("merge-field-postal"),
            value: "[CLIENTS.POSTAL_CODE]",
            type: "text"
        },
        {
            name: t("merge-field-country"),
            value: "[CLIENTS.COUNTRY]",
            type: "text"
        },
        {
            name: t("merge-field-website"),
            value: "[CLIENTS.WEBSITE]",
            type: "text"
        },
        {
            name: t("merge-field-phone"),
            value: "[CLIENTS.PHONE]",
            type: "text"
        },
        {
            name: t("merge-field-fax"),
            value: "[CLIENTS.FAX]",
            type: "text"
        },
        //List Information
        {
            name: t("merge-field-list-name"),
            value: "[LISTNAME]",
            type: "text"
        },
        {
            name: t("merge-field-contact-confirm-link"),
            value: "[CONFIRM_LINK]",
            type: "system-email",
            //desc: t("merge-field-contact-confirm-link-desc"),
        }
    ]

    if (account.isPartnerOrOrganization()) {
        mergeTags = mergeTags.concat([{
            name: t("merge-field-new_email"),
            value: "[NEW_EMAIL]",
            type: "system-email",
            //desc: t("merge-field-new_email-desc"),
        },
        {
            name: t("merge-field-client-confirm"),
            value: "[CLIENT.CONFIRMATION]",
            type: "system-email",
            //desc: t("merge-field-client-confirm-desc"),
        },
        {
            name: t("merge-field-expired-date"),
            value: "[EXPIRE_DATE]",
            type: "system-email",
            //desc: t("merge-field-expired-date-desc"),
        },
        {
            name: t("merge-field-requested-date"),
            value: "[REQUESTED_DATE]",
            type: "system-email",
            //desc: t("merge-field-requested-date-desc"),
        },
        {
            name: t("merge-field-reset-password"),
            value: "[RESET_PASSWORD_LINK]",
            type: "system-email",
            //desc: t("merge-field-password-desc"),
        },
        {
            name: t("merge-field-sender-confirm-link"),
            value: "[SENDER.CONFIRMATION_LINK]",
            type: "system-email",
            //desc: t("merge-field-sender-confirm-link-desc"),
        },
        {
            name: t("merge-field-user-confirm-link"),
            value: "[USER.CONFIRMATION]",
            type: "system-email",
            //desc: t("merge-field-user-confirm-link-desc"),
        },
        ])
    }

    return mergeTags
}

export function getSpecialLinks() {
    return [
        {
            type: "Subscription",
            label: t("bee-special-links-unsubscribe"),
            link: "[UNSUBSCRIBE]",
        },
        {
            type: "Subscription",
            label: t("bee-special-links-subscribe"),
            link: "[SUBSCRIBE]",
        },
        {
            type: "Subscription",
            label: t("bee-special-links-global_unsub"),
            link: "[GLOBAL_UNSUBSCRIBE]",
        },
        {
            type: "Subscription",
            label: t("bee-special-links-dopt-in"),
            link: "[CONFIRM_LINK]",
        },
        {
            type: "Content",
            label: t("bee-special-links-forward"),
            link: "[FORWARD]",
        },
        {
            type: "Content",
            label: t("bee-special-links-showemail"),
            link: "[SHOWEMAIL]",
        },
        {
            type: "Content",
            label: t("bee-special-links-share"),
            link: "[SHARE]",

        },
    ]
}
